import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import { ReactComponent as FlowIcon } from 'new/components/icons/fi-rr-diagram-subtask.svg';
import styles from './RelatedFlowsCard.module.scss';

const RelatedFlowsCard = ({ projectId, flowsCount = 0 }) => {
  if (!projectId) return null;

  return (
    <div className={styles.card}>
      <div className={styles.topRow}>
        <div className={styles.iconContainer}>
          <FlowIcon className={styles.icon} />
        </div>
        <div className={styles.count}>{flowsCount}</div>
      </div>
      <div className={styles.bottomRow}>
        <div className={styles.automationsText}>All Project Data Flows</div>
        <Link to={`/integrate/projects/${projectId}`} className={styles.link}>
          <Typography variant="caption" color="primary">
            View List →
          </Typography>
        </Link>
      </div>
    </div>
  );
};

export default RelatedFlowsCard;
